import React from "react";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";

export const PrivateRoute = ({ header: Header, component: Component, ...rest }) => {
  // const postal = JSON.parse(sessionStorage.getItem("postal"));
  const postal = rest.location.state.postalCode
  const permissionGranted = postal && postal !== "";
  const path = permissionGranted ? "/" : "/energy-cost-cal";
  return (
    <Route
      {...rest}
      render={props => {
        return permissionGranted ? (
          <div>
            {Header && <Header {...props} />}
            <Component {...props} />
          </div>
        ) : (
          <Redirect
            to={{
              pathname: path,
              state: { from: props.location }
            }}
          />
        );
      }}
    ></Route>
  );
};

PrivateRoute.propTypes = {
  header: PropTypes.any,
  component: PropTypes.any,
  location: PropTypes.any
};
